module.exports = __webpack_public_path__ + "img/icon_system_implementation.6120a848.svg";